var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Lernmaterial exportieren"),
      confirmText: _vm.$gettext("Exportieren"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "350",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.executeExport,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c("courseware-companion-box", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.exportRunning,
                  expression: "!exportRunning",
                },
              ],
              attrs: {
                msgCompanion: _vm.$gettextInterpolate(
                  _vm.$gettext("Export des Lernmaterials: %{title}"),
                  {
                    title: _vm.title,
                  }
                ),
                mood: "curious",
              },
            }),
            _vm._v(" "),
            _c("courseware-companion-box", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exportRunning,
                  expression: "exportRunning",
                },
              ],
              attrs: {
                msgCompanion: _vm.$gettextInterpolate(
                  _vm.$gettext(
                    "%{title} wird exportiert, bitte haben sie einen Moment Geduld..."
                  ),
                  {
                    title: _vm.title,
                  }
                ),
                mood: "pointing",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exportRunning,
                    expression: "exportRunning",
                  },
                ],
                staticClass: "cw-import-zip",
              },
              [
                _c("header", [_vm._v(_vm._s(_vm.exportState) + ":")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "progress-bar-wrapper",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress-bar",
                        style: {
                          width: _vm.exportProgress + "%",
                        },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": _vm.exportProgress,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.exportProgress) +
                            "%\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }